import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const contactRequestEmailVerificationRoute = () =>
  [
    HgSupportedLanguage.DE,
    HgSupportedLanguage.EN,
    HgSupportedLanguage.FR,
    HgSupportedLanguage.IT,
  ].map((locale) => ({
    path: `/${locale}/contact-request/verify`,
    component: () =>
      import('@/views/ContactRequestEmailVerificationPage/ContactRequestEmailVerificationPage.vue'),
    name: `contactRequestEmailVerification-${locale}`,
    meta: {
      locale,
      viewName: 'Contact Request Email Verification Page',
      getLanguageSwitchLink(route: any, locale: HgSupportedLanguage) {
        return {
          name: `contactRequestEmailVerification-${locale}`,
          query: route.query,
          params: route.params,
        };
      },
    },
  }));
